import styled from '@emotion/styled';
import { spacing } from '@identity/spacing';

import * as c from '@identity/constants';

export const Content = styled.div`
  display: grid;
  grid-template-areas: 'b' 'a';
  background: ${c.colors.PRIMARY_007};

  ${c.TABLET} {
    grid-template-columns: repeat(2, 1fr);
    grid-template-areas: ${props => (props.reverseContent ? "'b a'" : "'a b'")};
    grid-auto-flow: column;
  }
`;

export const RatioContainer = styled.div`
  ${c.TABLET} {
    height: 0;
    padding-bottom: ${props =>
      props.imageRatio ? `${props.imageRatio}%` : ''};
    grid-area: a;
    visibility: hidden;
  }
`;

export const Text = styled.article`
  ${spacing({
    padding: {
      default: 'all-sm',
      desktop: 'all-lg',
    },
  })};

  grid-area: a;
  display: grid;
  place-content: center;
`;

export const Media = styled.div`
  height: 30vh;
  position: relative;
  overflow: hidden;
  grid-area: b;

  ${c.TABLET} {
    height: 100%;
  }
`;
